export default __webpack_public_path__ + "static/media/Acilom.2f67ac77.png";